<template>
  <div>
    <v-icon
      class="d-flex justify-center flex-column"
      :color="color ? color : 'secondary'"
      :size="$vuetify.breakpoint.smAndDown ? Math.round(size - (size * 0.33)) : size"
    >
      mdi-{{ icon }}
    </v-icon>
    <p :class="[
      'text-center',
      `${$vuetify.breakpoint.smAndDown ? 'subtitle-1' : 'title'}`,
      'ma-0',
      'font-weight-bold',
      `${color ? color : 'primary'}--text`
    ]">
      {{ title }}
    </p>
    <p pa-1 :class="[
      'text-center',
      `${$vuetify.breakpoint.smAndDown ? 'caption' : 'body-2'}`,
      'font-weight-light',
      `${color ? color : 'secondary'}--text`
    ]">
      {{ subtitle }}
    </p>
  </div>
</template>

<script>
export default {
  props: ['size', 'title', 'subtitle', 'icon', 'color'],
};
</script>
